import React, { useContext } from "react";

/// React router dom
import { Routes, Route, Outlet } from "react-router-dom";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./layouts/ScrollToTop";
/// Dashboard
import Dashboard from "./components/Dashboard/Dashboard";
import CustomerList from "./components/Dashboard/CustomerList";
import CustomerDetails from "./components/Dashboard/CustomerDetails";
import PackageList from "./components/Dashboard/PackageList";
import Reviews from "./components/Dashboard/Reviews";

/////Demo
import Theme1 from "./components/Dashboard/Demo/Theme1";
import Theme2 from "./components/Dashboard/Demo/Theme2";
import Theme3 from "./components/Dashboard/Demo/Theme3";
import Theme4 from "./components/Dashboard/Demo/Theme4";
import Theme5 from "./components/Dashboard/Demo/Theme5";
import Theme6 from "./components/Dashboard/Demo/Theme6";

/// App
import AppProfile from "./components/AppsMenu/AppProfile/AppProfile";
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";
import Calendar from "./components/AppsMenu/Calendar/Calendar";
import PostDetails from "./components/AppsMenu/AppProfile/PostDetails";

/// Pages
import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import { ThemeContext } from "../context/ThemeContext";
import Leave from "./components/Dashboard/Leave";
import Queries from "./components/Dashboard/Queries";
import PackageDetails from "./components/Dashboard/PackageDetails";
import Attendance from "./components/Dashboard/Attendance";
import Vendors from "./components/Dashboard/Vendors";
import LeadManagement from "./components/Dashboard/Lead";
import Bookings from "./components/Dashboard/Bookings";
import TicketBooking from "./components/Dashboard/TicketBookingHistory";
import Inquiry from "./components/Dashboard/Inquiry";
import TourBooking from "./components/Dashboard/TourBookings";
import Complaints from "./components/Dashboard/Complaints";
import Contacts from "./components/Dashboard/Contacts";

const Markup = () => {
  // const { menuToggle } = useContext(ThemeContext);
  const allroutes = [
    /// Dashboard
    { url: "", component: <Dashboard /> },
    { url: "dashboard", component: <Dashboard /> },
    { url: "customer-list", component: <CustomerList /> },
    { url: "/customer-details/:bookingId", component: <CustomerDetails /> },
    { url: "package-list", component: <PackageList /> },
    { url: "vendors", component: <Vendors /> },
    { url: "reviews", component: <Reviews /> },
    { url: "attendance", component: <Attendance /> },
    { url: "leaves", component: <Leave /> },
    { url: "queries", component: <Queries /> },
    { url: "complaints", component: <Complaints /> },
    { url: "contacts", component: <Contacts /> },


    { url: "/package-details/:packageId", component: <PackageDetails /> },
    { url: "lead-management", component: <LeadManagement /> },
    { url: "/tour-booking", component: <TourBooking /> },
    { url: "/hotel-booking", component: <Bookings /> },

    { url: "/flight-booking", component: <TicketBooking /> },
    { url: "/admission-enquiries", component: <Inquiry /> },

    ///Demo
    { url: "primary-sidebar", component: <Theme1 /> },
    { url: "mini-primary-sidebar", component: <Theme2 /> },
    { url: "compact-primary-header", component: <Theme3 /> },
    { url: "horizontal-primary-sidebar", component: <Theme4 /> },
    { url: "horizontal-modern-sidebar", component: <Theme5 /> },
    { url: "modern-sidebar", component: <Theme6 /> },

    /// Apps
    { url: "app-profile", component: <AppProfile /> },
    { url: "post-details", component: <PostDetails /> },
    { url: "email-compose", component: <Compose /> },
    { url: "email-inbox", component: <Inbox /> },
    { url: "email-read", component: <Read /> },
    { url: "app-calender", component: <Calendar /> },

    /// pages
    //{ url: "page-register", component: Registration },
    //{ url: "page-lock-screen", component: LockScreen },
    //{ url: "page-login", component: Login },
    //{ url: "page-forgot-password", component: ForgotPassword },
    // { url: "page-error-400", component: Error400 },
    // { url: "page-error-403", component: Error403 },
    // { url: "page-error-404", component: Error404 },
    // { url: "page-error-500", component: Error500 },
    // { url: "page-error-503", component: Error503 },
  ];
  return (
    <>
      <Routes>
        <Route path="page-lock-screen" element={<LockScreen />} />
        <Route path="page-error-400" element={<Error400 />} />
        <Route path="page-error-403" element={<Error403 />} />
        <Route path="page-error-500" element={<Error500 />} />
        <Route path="page-error-503" element={<Error503 />} />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => {
            return (
              <Route
                key={i}
                exact
                path={`${data.url}`}
                element={data.component}
              />
            );
          })}
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { menuToggle, sidebariconHover } = useContext(ThemeContext);
  return (
    <div
      id="main-wrapper"
      className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${
        menuToggle ? "menu-toggle" : ""
      }`}
    >
      <Nav />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height - 45 }}
      >
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}
export default Markup;
